import { Component, inject, input } from '@angular/core';
import { RouterModule } from '@angular/router';
import { AclDirective } from 'app/shared/acl/acl-resource.directive';
import { Resource } from 'app/shared/acl/acl.model';
import { UiModule } from 'app/shared/ui';
import { UpgradeBundleModalComponent } from '../feature-bundle/upgrade-bundle-modal.component';
import { ModalsService } from '../ui/modals/modals.service';


@Component({
    selector: 'feature-sheet-link',
    imports: [
        RouterModule,
        AclDirective,
        UiModule,
    ],
    styles: [
        `
        .btn {
            font-size: inherit;
        }
        .btn.btn-link {
            padding: 0;
            vertical-align: baseline;
            line-height: 1;
        }
        .btn.btn-link.loading ::ng-deep span {
            visibility: visible !important;
        }
        .btn.btn-link.loading ::ng-deep .loader {
            position: static;
            margin-left: 0.25em;
            color: #202020;
        }
        .btn.btn-link.disabled {
            cursor: pointer;
            pointer-events: auto;
            opacity: 1;
            text-decoration: none;
        }
        `,
    ],
    template: `
        <a *apAcl="r.APP_CMA" class="btn btn-link" [routerLink]="['/dashboard', 'feature', upidOrMls()]" loading>
            Active MLS&reg; Feature Sheet
        </a>
        <button *apAcl="r.UPGRADE_TO_AUTOPROP_PRO" class="btn btn-link disabled" (click)="openUpgradeBundleModal()">
            Active MLS&reg; Feature Sheet
            <img alt="" src="/assets/images/skills-centre/lock.svg">
        </button>
    `,
})
export class FeatureSheetLinkComponent {

    upidOrMls = input.required<string>();

    r = Resource;

    private modalsService = inject(ModalsService);

    openUpgradeBundleModal() {
        this.modalsService.openModal(UpgradeBundleModalComponent);
    }
}
